import { Text } from "@prismicio/editor-ui"
import { useEffect, useRef, useState } from "react"

interface CountdownProps {
  countdown: number
}

export function Countdown(props: CountdownProps) {
  const { countdown } = props

  const [count, setCount] = useState(countdown)
  const timeoutId = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (count > 0) {
      timeoutId.current = setTimeout(() => {
        setCount(count - 1)
      }, 1_000)
    }

    return () => {
      timeoutId.current && clearTimeout(timeoutId.current)
    }
  }, [count])

  return <Text color="white">{count}s</Text>
}
